export class CloseMenuOptionsSheet {
    constructor(optionalOptions = {}) {
        this._buttons = document.querySelectorAll('.modal-close--option');

        if (!this._buttons) {
            this.destructor();
            return true;
        }

        this._buttons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();

                button.closest('.menu-choosing-option--open').style.display = "none";

                document.querySelector('body').classList.remove('no-scroll');
            })
        })
    }

    destructor() {
        this._buttons = null;
    }
}

export default new CloseMenuOptionsSheet();
